export default __webpack_public_path__ + "static/media/HealthCampBg.7a56acd4.png";